module.exports = __webpack_public_path__ + "img/card-small-b3.f7abe21d.png";